import { Body, Button, Form, Spacer } from '@spritz-finance/ui'
import { useEffect, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { useConfirmUser } from '../../app/auth'
import {
    AuthenticationBottomLink,
    AuthenticationBottomText,
    AuthenticationContainer,
    AuthenticationForm,
} from '../AuthenticationStyled'

interface ConfirmEmailProps {
    email: string
    password: string
    notConfirmed?: boolean
}

interface ConfirmFormData {
    code: string
}

export default function ConfirmEmail({ email, password }: ConfirmEmailProps) {
    const [resentConfirmation, setResentConfirmation] = useState<boolean>(false)
    const { resendConfirmationCode, confirmSignUp, loading, error } = useConfirmUser()

    const onSubmit: SubmitHandler<ConfirmFormData> = async ({ code }) => {
        confirmSignUp(email, password, code)
    }

    const resendConfirmation = () => {
        resendConfirmationCode(email)
        setResentConfirmation(true)
    }

    const methods = useForm<ConfirmFormData>()

    useEffect(() => {
        if (!error) return
        methods.setError('code', error)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error])

    return (
        <AuthenticationContainer>
            <AuthenticationForm>
                <Body.Med size={14}>
                    We just sent an email with a verification code. Please submit that here.
                </Body.Med>
                <Spacer height={16} />
                <Form<ConfirmFormData> onSubmit={onSubmit} methods={methods} width="auto">
                    <Form.Input
                        name="code"
                        placeholder="Verification code"
                        validation={{
                            required: true,
                            pattern: {
                                value: /\d{6}/,
                                message: 'Invalid code',
                            },
                        }}
                    />
                    <Button.CTA type="submit" loading={loading} style={{ maxWidth: 'none' }}>
                        Continue
                    </Button.CTA>
                </Form>

                <AuthenticationBottomText>
                    {resentConfirmation
                        ? "Didn't get an email?"
                        : "Sent. Still haven't gotten an email?"}
                    <AuthenticationBottomLink onClick={resendConfirmation}>
                        Send Again
                    </AuthenticationBottomLink>
                </AuthenticationBottomText>
            </AuthenticationForm>
        </AuthenticationContainer>
    )
}
